// Global
import React from 'react';
import clsx from 'clsx';

// Local
import { HeroProps } from '../Hero';
import styles from './HeroGeneral.module.scss';
import { HeroDetailCard } from '../HeroDetailCard/HeroDetailCard';
import { useIsMobile } from 'lib/hooks/useIsMobile';
import { HeroDecor } from '../HeroDecor/HeroDecor';
import { ActionToolbar } from 'components/helpers/ActionToolbar';

export const HeroGeneral = (props: HeroProps) => {
  const isMobile = useIsMobile();

  const positionClasses = props?.contentPosition?.split(' ')?.map((c) => styles[c]) || [
    styles['hero-card-left'],
  ];

  // Extract content alignment from contentPosition
  const getContentAlignmentAndContentPosition = (): {
    contentAlignment: 'left' | 'center';
    contentPosition: 'hero-card-left' | 'hero-card-center' | 'hero-card-right' | 'hero-card-bottom';
  } => {
    const positions = props.contentPosition?.split(' ') || [];
    if (positions.includes('hero-card-center'))
      return { contentAlignment: 'center', contentPosition: 'hero-card-center' };
    if (positions.includes('hero-card-bottom'))
      return { contentAlignment: 'center', contentPosition: 'hero-card-bottom' };
    if (positions.includes('hero-card-right'))
      return { contentAlignment: 'left', contentPosition: 'hero-card-right' };
    return { contentAlignment: 'left', contentPosition: 'hero-card-left' }; // default
  };

  const { contentAlignment, contentPosition } = getContentAlignmentAndContentPosition();
  /*
   * Rendering
   */
  return (
    <div className={clsx(styles.heroGeneral, styles[`gridWrapper--${contentPosition}`])}>
      <div className={styles.imageContainer}>
        {props?.contentPageImage}
        {props?.contentPageImage && contentPosition !== 'hero-card-bottom' && <HeroDecor />}
      </div>
      <div className={clsx(styles.contentWrapper, positionClasses)}>
        <div className={styles.heroGeneralContentWrapper}>
          <HeroDetailCard {...props} contentAlignment={isMobile ? 'left' : contentAlignment} />
          {!props.disableHeroActionToolbar && (
            <div
              className={clsx(
                styles.actionToolBarContainer,
                props.isArticlePage && styles.articlePageAlignment
              )}
            >
              <ActionToolbar
                actions={props.heroActionToolbarButtons}
                toolbarIdentifier={props.heroActionToolbarIdentifier}
                variant="horizontal"
                className={!props.isArticlePage ? styles.centerAlignActionToolbar : undefined}
              />
            </div>
          )}
        </div>
      </div>
      {props?.externalPageImage && (
        <div className={clsx(styles.heroGeneralExternalImageWrapper)}>
          {props?.editingHelpText}
          {props?.externalPageImage}
        </div>
      )}
    </div>
  );
};
